import { HTTP } from "./HttpServices";
const endpoint = "/pets";

const getPets = query => {
  return HTTP.get(endpoint.concat(query)).then(resp => resp);
};

const create = pet => {
  return HTTP.post(endpoint, pet);
};

const update = pet => {
  return HTTP.put(endpoint.concat("/").concat(pet.id), pet);
};

const remove = petId => {
  return HTTP.delete(endpoint.concat("/").concat(petId));
};

const getDeliveriesReportByPetIdAndPeriod = (petId, startDate, endDate) => {
  return HTTP.get(`/deliveryproducts${endpoint}/${petId}/period?startDate=${startDate}&endDate=${endDate}`);
}

export default {
  getPets,
  create,
  update,
  remove,
  getDeliveriesReportByPetIdAndPeriod
};
